// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".incident-cards[data-v-7e7706d6]{grid-gap:15px;display:grid}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Customers/BusinessIncidents/Edit.vue"],"names":[],"mappings":"AACA,iCAEI,aAAA,CADA,YACA","sourcesContent":["\n.incident-cards {\n    display: grid;\n    grid-gap: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
